import { cx } from '@linaria/core';
import { useCallback } from 'react';
import { useFormikContext } from 'formik';
import { InputField } from 'components/ui_library/Formik';
import { Alert } from 'components/Alert';
import { selectModelTypeFieldTypeInfo } from 'modules/Models/components/ModelForm/utils/utils';
import { formContainer, inputContainer, inputStyle, textGenInputStyle } from 'modules/Models/components/ModelForm/styles';
import { FormikInitialValues } from 'modules/Models/components/ModelForm/utils/types';
import { TEXT_GEN_MODEL_TYPES } from 'modules/Models/types';
import { FormLabel } from './FormLabel';
import { textInputFormFieldStyled } from './TextInputFormElement.styled';
type TextInputFormElementProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: string;
  labelTitle?: string;
  path: string;
  transformInput?: (value: unknown) => unknown;
  transformValue?: (value: unknown) => unknown;
  field?: CF.API.Models.ModelTypeFieldsEntity;
};

// labelTitle is passed as a prop to allow the Model Name and Model Id fields
// to reuse the same component as field type 2 elements.
export const TextInputFormElement = ({
  path,
  error,
  disabled,
  labelTitle = path,
  transformInput,
  transformValue,
  style,
  field
}: TextInputFormElementProps) => {
  const {
    values,
    setFieldValue
  } = useFormikContext();
  const {
    fieldValueMap,
    modelType
  } = (values as FormikInitialValues);
  const {
    description = '',
    placeholder = ''
  } = selectModelTypeFieldTypeInfo(path, (values as FormikInitialValues), field);
  const formInputValue = fieldValueMap[path];
  const inputValue = transformValue ? transformValue(formInputValue) : formInputValue;
  const onChange = useCallback(e => {
    const newValue = transformInput === undefined ? e.target.value : transformInput(e.target.value);
    setFieldValue('fieldValueMap', {
      ...fieldValueMap,
      [path]: newValue
    });
  }, [fieldValueMap, path]);
  const isMultiLine = fieldShouldBeMultiline(path);
  const isTextGenView = TEXT_GEN_MODEL_TYPES.includes(modelType);
  return <div className={formContainer}>
      <div className={cx(inputContainer, path !== 'modelId' && 'border')}>
        <FormLabel path={labelTitle} description={(description as string)} />
        <div className={cx(inputStyle, isTextGenView && textGenInputStyle)}>
          <InputField name="input" type="text" isMultiLine={isMultiLine} id={path} placeholder={placeholder} value={(inputValue as string)} onChange={onChange} disabled={disabled} style={style} className={textInputFormFieldStyled} />
          {isTextGenView && !error && description && <span className="description">{description}</span>}
          {error && <Alert type="error">{error}</Alert>}
        </div>
      </div>
    </div>;
};

/**
 * Determines whether a given field should be rendered with a multiline text input (textarea).
 * @param path The field path.
 */
function fieldShouldBeMultiline(path: string): boolean {
  return path === 'output_info.params.prompt_template';
}